module.exports = __webpack_public_path__ + "img/rec_4.cb4e5630.png";